<template>
    <div>
        <template v-if="extrasToEdit && extrasToEdit.length > 0">
            <table class="w-100 dark mb-4">
                <tr class="fs-small">
                    <th class="extraNameWidth">Extra</th>
                    <th class="pb-2">Seller</th>
                    <th class="pb-2 text-center">Commission</th>
                    <th class="pb-2 text-center" style="width: 100px;">Availability</th>
                    <th class="pb-2 text-center" style="width: 120px;">Price/unit</th>
                    <th class="pb-2 text-center" style="width: 150px;">Quantity</th>
                </tr>

                <tr class="border-bottom-light border-top-light" v-for="extra in extrasToEdit">
                    <td class="darker">{{ extra.component.name }} - {{ extra.componentPrice.name }}<span v-if="!showEditControls(extra)" class="color-6">*</span></td>
                    <td class="fs-small">{{ showSeller(extra) }}</td>
                    <td class="fs-small text-center">{{ showCommission(extra) }}</td>
                    <td class="fs-small text-center">{{ showAvailability(extra) }}</td>
                    <td class="fs-small text-center">{{ formatPrice(extra.componentPrice.grossprice) }} €</td>

                    <td v-if="!showEditControls(extra)" class="fs-small text-center">{{ extra.quantity }}</td>
                    <td v-else class="d-flex flex-row justify-content-center py-1">
                        <span class="border-light py-1 px-2 radius-normal mx-1 text-center pointer" @click="changeExtraQtd2('remove', extra, 'extra')"><i class="ico ico-minus dark fs-smaller m-0"></i></span>
                        <input type="number" placeholder="0" min="0" class="text-center fs-larger px-1 py-0 bg-lighter darker" style="width: 2.2rem" :value="extra.quantity" @input="debouncedQuantityChanged(extra, $event.target.value)" @focus="extraFocused(extra)">
                        <span class="border-light py-1 px-2 radius-normal mx-1 text-center pointer" @click="changeExtraQtd2('add', extra, 'extra')"><i class="ico ico-add dark fs-smaller m-0"></i></span>
                    </td>
                </tr>

                <tr class="fs-large" v-if="!extrasTransportToEdit.length">
                    <th class="pt-2 extraNameWidth">Total</th>
                    <th class="pt-2 pb-2"></th>
                    <th class="pt-2 pb-2"></th>
                    <th class="pt-2 pb-2"></th>
                    <th class="pt-2 pb-2 text-center">{{formatPrice(calculatedExtrasTotal)}} €</th>
                    <th class="pt-2 addRemoveWidth text-center">{{totalExtras}}</th>
                </tr>
            </table>
        </template>

        <template v-if="extrasTransportToEdit && extrasTransportToEdit.length > 0">
            <table class="w-100 dark mb-4">
                <tr class="fs-small">
                    <th class="extraNameWidth">Transport</th>
                    <th class="pb-2">Seller</th>
                    <th class="pb-2 text-center">Commission</th>
                    <th class="pb-2 text-center" style="width: 100px;">Availability</th>
                    <th class="pb-2 text-center" style="width: 120px;">Price/unit</th>
                    <th class="pb-2 text-center" style="width: 150px;">Quantity</th>
                </tr>

                <tr class="border-bottom-light border-top-light" v-for="extra in extrasTransportToEdit">
                    <td class="darker">{{ extra.component.name }} - {{extra.componentPrice.name}}<span v-if="!showEditControls(extra)" class="color-6">*</span></td>
                    <td class="fs-small">{{showSeller(extra)}}</td>
                    <td class="fs-small text-center">{{showCommission(extra)}}</td>
                    <td class="fs-small text-center">{{showAvailability(extra)}}</td>
                    <td class="fs-small text-center">{{ formatPrice(extra.componentPrice.grossprice) }} €</td>

                    <td v-if="!showEditControls(extra)" class="fs-small text-center">{{ extra.quantity }}</td>
                    <td v-else class="d-flex flex-row justify-content-center py-1">
                        <span class="border-light py-1 px-2 radius-normal mx-1 text-center pointer" @click="changeExtraQtd2('remove', extra, 'transport')"><i class="ico ico-minus dark fs-smaller m-0"></i></span>
                        <input type="number" placeholder="0" min="0" class="text-center fs-larger px-1 py-0 bg-lighter darker" style="width: 2.2rem" :value="extra.quantity" @input="debouncedQuantityChanged(extra, $event.target.value)" @focus="extraFocused(extra)">
                        <span class="border-light py-1 px-2 radius-normal mx-1 text-center pointer" @click="changeExtraQtd2('add', extra, 'transport')"><i class="ico ico-add dark fs-smaller m-0"></i></span>
                    </td>
                </tr>

                <tr class="fs-large">
                    <th class="pt-2 extraNameWidth">Total</th>
                    <th class="pt-2 pb-2"></th>
                    <th class="pt-2 pb-2"></th>
                    <th class="pt-2 pb-2"></th>
                    <th class="pt-2 pb-2 text-center">{{formatPrice(calculatedExtrasTotal)}} €</th>
                    <th class="pt-2 addRemoveWidth text-center">{{totalExtras}}</th>
                </tr>
            </table>
        </template>

        <div v-else-if="!extrasTransportToEdit.length && !extrasToEdit.length" class="fs-large dark text-center p-2">
            There are no extras to show
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import { reservationsMixin } from '@/mixins/reservations'
    import { event } from 'vue-analytics';

    import debounce from 'lodash/debounce';

    export default {
        data() {
            return {
                extraItemLoaction: null,
                extrasToEdit: [],
                extrasTransportToEdit: [],
            }
        },
        props: {
            reservation: {
                type: Object
            },
            extrasArrayImported: {
                type: Array
            },
            readOnly: {
                type: Boolean,
                default: false
            },
            allowChangeUnsaved: {
                type: Boolean,
                default: false
            }
        },
        created() {
            this.setExtrasToEdit();
            this.debouncedQuantityChanged = debounce(this.quantityChanged, 750);
        },
        mixins: [
            reservationsMixin
        ],
        computed: {
            ...mapGetters([
                'getReservationCalculations',
                'getSalesChannels'
            ]),
            totalExtras() {
                let total = 0;

                for (let extra of this.extrasArrayImported) {
                    if (extra.quantity) {
                        total += Number(extra.quantity);
                    }
                }
                
                return total;
            },
            calculatedExtrasTotal() {
                let total = 0;

                this.extrasArrayImported.map(extra => {
                    total += Number(extra.componentPrice.grossprice) * extra.quantity;
                });

                return total;
            },
            calculateTotalPax() {
                return this.reservation.bookingGenderPrices.reduce((acc, comp) => {
                    return acc += comp.quantityToBook;
                }, 0);
            },
        },
        methods: {
            ...mapActions([
                'setReservationCalculations'
            ]),
            showEditControls(row) {
                if (this.readOnly == false) {
                    return true;
                } else if (this.readOnly == true && this.allowChangeUnsaved == false) {
                    return false;
                } else if (this.allowChangeUnsaved == true && row.id == null) {
                    return true;
                } else {
                    return false;
                }
            },
            setExtrasToEdit() {
                // Create two new arrays. One with extras and other with transports
                for (const extra of this.extrasArrayImported) {
                    if (extra.quantity > 0) {
                        if (extra.component.componentType === 0) {
                            this.extrasToEdit.push(extra);
                        } else if (extra.component.componentType === 1) {
                            this.extrasTransportToEdit.push(extra);
                        }
                    }
                }
            },
            showSeller(extra) {
                if (extra.creatorAgent) {
                    return extra.creatorAgent.brandName;
                    // When it's selled by Widget or any other OTA (channeltype > 100) it should always show channel name instead of UserAccount name
                } else if (extra.creatorUserAccount && (extra.channelType < 100 || extra.channelType == 9999)) {
                    return extra.creatorUserAccount.name;
                } else {
                    return this.getSalesChannels.find(channel => channel.channelType == extra.channelType).brandName;
                }
            },
            showAvailability(extra) {
                if (extra.originalQuantity == 0) {
                    return 'unlimited';
                } else {
                    return isNaN(extra.quantityAvailable)? '' : extra.quantityAvailable;
                }
            },
            extraQtd2(extra){
                return extra.quantity;
            },
            showCommission(extra) {
                if (extra.commissionComponentValue != null && extra.commissionComponentValueType != null) {
                    return `${extra.commissionComponentValue} ${extra.commissionComponentValueType == 1 ? '%' : '€'}`;
                }

                return null;
            },
            changeExtraQtd2(action, extra, extraType) {
                const isTransport = extraType === 'transport';

                if (this.isReservationReadOnly) {
                    this.readOnlyShowMessage();
                    return false;
                }

                const totalPax = this.calculateTotalPax;
                const maxPersonsForTransport = isTransport && extra.quantity === totalPax;

                if (action === 'add') {
                    if (extra.componentExtinct) {
                        this.$toasted.info('This extra is no longer available on this product.');
                        return false;
                    }

                    if (isTransport && maxPersonsForTransport) {
                        this.$toasted.success('All pax with transport!', { duration: 5000 });
                        return;
                    }

                    if (extra.originalQuantity === 0 || extra.quantityAvailable > 0) {
                        if (extra.id !== null) {
                            if (extra.originalQuantity === 0 || extra.quantity < extra.initialValue) {
                                this.$set(extra, 'quantity', extra.quantity + 1);
                            } else {
                                this.$set(extra, 'quantity', extra.quantity + 1);
                                this.$set(extra, 'quantityToAdd', (extra.quantityToAdd || 0) + 1);
                            }
                        } else {
                            this.$set(extra, 'quantity', extra.quantity + 1);
                            this.$set(extra, 'quantityToAdd', (extra.quantityToAdd || 0) + 1);
                        }

                        if (extra.originalQuantity !== 0) {
                            this.$set(extra, 'quantityAvailable', extra.quantityAvailable - 1);
                        }
                    } else if (isTransport) {
                        this.$toasted.error('No more seats available!', { duration: 5000 });
                    }
                } else if (action === 'remove') {
                    if (extra.quantity > 0) {
                        if (extra.quantityToAdd > 0) {
                            if (extra.originalQuantity === 0) {
                                if (extra.id !== null && extra.quantity <= extra.initialValue) {
                                    this.$set(extra, 'quantity', extra.quantity - 1);
                                } else {
                                    this.$set(extra, 'quantity', extra.quantity - 1);
                                    this.$set(extra, 'quantityToAdd', extra.quantityToAdd - 1);
                                }
                            } else {
                                if (extra.id === null && extra.quantityAvailable === 0) {
                                    this.$set(extra, 'quantityAvailable', 1);
                                } else {
                                    this.$set(extra, 'quantityAvailable', extra.quantityAvailable + 1);
                                }

                                this.$set(extra, 'quantity', extra.quantity - 1);
                                this.$set(extra, 'quantityToAdd', extra.quantityToAdd - 1);
                            }
                        } else if (!extra.quantityToAdd) {
                            if (extra.originalQuantity === 0) {
                                this.$set(extra, 'quantity', extra.quantity - 1);
                            } else if (extra.quantityAvailable < extra.originalQuantity) {
                                this.$set(extra, 'quantity', extra.quantity - 1);
                                this.$set(extra, 'quantityAvailable', extra.quantityAvailable + 1);
                            }
                        }

                        if (extra.quantity === 0) {
                            this.updateTransfersList(extra);
                        }
                    }
                }

                this.syncAvailabiliity(extra);
            },
            quantityChanged(extra, newVal) {
                const numericNewVal = Number(newVal);

                // Saves the previous values if they have not already been saved
                if (!('previousQuantityAvailable' in extra)) {
                    extra.previousQuantityAvailable = extra.quantityAvailable;
                    extra.previousQuantity = extra.quantity;
                    extra.previousQuantityToAdd = extra.quantityToAdd || 0;
                } else {
                    extra.quantityAvailable = extra.previousQuantityAvailable;
                    extra.quantity = extra.previousQuantity;
                    extra.quantityToAdd = extra.previousQuantityToAdd;
                }

                const isUnlimited = extra.originalQuantity === 0;
                const initialValue = extra.initialValue;

                if (isUnlimited) {
                    if (numericNewVal > initialValue) {
                        const difference = numericNewVal - initialValue;
                        extra.quantityToAdd = difference;
                        extra.quantity = initialValue + difference;
                    } else {
                        extra.quantityToAdd = 0;
                        extra.quantity = numericNewVal;
                    }
                } else {
                    if (numericNewVal <= extra.quantityAvailable) {
                        const previousQuantity = extra.quantity;

                        if (numericNewVal > initialValue) {
                            extra.quantityToAdd = numericNewVal - previousQuantity;
                            extra.quantityAvailable -= (numericNewVal - previousQuantity);
                            extra.quantity = numericNewVal;
                        } else if (numericNewVal === initialValue) {
                            extra.quantityToAdd = 0;
                            extra.quantity = numericNewVal;
                        } else {
                            extra.quantityAvailable -= numericNewVal;
                            extra.quantityToAdd = 0;
                            extra.quantity = numericNewVal;
                        }
                    } else {
                        const previousValidValue = extra.quantity;
                        this.$toasted.error('Selected quantity can not be higher than available quantity');
                        this.$set(extra, 'quantity', null);
                        this.$set(extra, 'quantity', previousValidValue);
                    }
                }

                // Synchronization of availability and calculations
                this.syncAvailabiliity(extra);
                this.setReservationCalculations(this.reservation);
            },
            extraFocused(extra) {
                // Fix to simulate "placeholder" with 0 value
                if (extra.quantity == 0) {
                    extra.quantity = null;
                }
            },
            syncAvailabiliity(currentComponent) {
                this.reservation.bookingComponents.map(bookingComponent => {
                    if (bookingComponent.component && bookingComponent.componentPrice &&
                        bookingComponent.component.id === currentComponent.component.id && 
                        bookingComponent.componentPrice.id === currentComponent.componentPrice.id) {

                        if (bookingComponent !== currentComponent) {
                            this.$set(bookingComponent, 'quantityAvailable', currentComponent.quantityAvailable);
                        }

                        if (bookingComponent.id === null && currentComponent.id === null) {
                            this.$set(bookingComponent, 'quantityAvailable', currentComponent.quantityAvailable);
                            this.$set(bookingComponent, 'quantityToAdd', currentComponent.quantityToAdd || 0);
                            this.$set(bookingComponent, 'quantity', currentComponent.quantity || 0);
                        }

                        if (bookingComponent.id !== null && currentComponent.id !== null && bookingComponent.id === currentComponent.id) {
                            this.$set(bookingComponent, 'quantityAvailable', currentComponent.quantityAvailable);
                            this.$set(bookingComponent, 'quantity', currentComponent.quantity);
                            if (currentComponent.hasOwnProperty('quantityToAdd')) {
                                this.$set(bookingComponent, 'quantityToAdd', currentComponent.quantityToAdd);
                            }
                        }
                    }
                });

                this.reservation.event.eventComponents.map(eventComponent => {
                    if (eventComponent.component && eventComponent.componentPrice &&
                        eventComponent.component.id === currentComponent.component.id &&
                        eventComponent.componentPrice.id === currentComponent.componentPrice.id) {
                        
                        if (currentComponent.id === null) {
                            eventComponent.quantity = currentComponent.originalQuantity;
                            eventComponent.quantityAvailable = currentComponent.quantityAvailable;
                            eventComponent.quantityToAdd = currentComponent.quantityToAdd;
                        } else {
                            eventComponent.quantity = currentComponent.originalQuantity;
                            eventComponent.quantityAvailable = currentComponent.quantityAvailable;
                        }
                    }
                });

                this.finalSyncQuantity(currentComponent);
            },
            finalSyncQuantity(currentComponent) {
                this.extrasArrayImported.forEach(extra => {
                    if (
                        extra.component &&
                        extra.componentPrice &&
                        extra.component.id === currentComponent.component.id &&
                        extra.componentPrice.id === currentComponent.componentPrice.id
                    ) {
                        this.$set(extra, 'quantityAvailable', currentComponent.quantityAvailable);
                    }
                });
            },
            updateTransfersList(extra) {
                if (extra.quantity > 0) {
                    this.eventHub.$emit('routeForm_updateTransportTransfer', true);
                } else {
                    // The route-form component has to be initialised to catch event emit otherwise will do nothing
                    // When only edit in reservation route-form has not been initialised and we should delete transfers anyway
                    this.reservation.transport.transfers = [];
                } 
            },
        }
    }
</script>

<style lang="scss" scoped>
    .disable-btn {
        background-color: #dbdfe29c;
    }
</style>



// WEBPACK FOOTER //
// ExtrasManager.vue?ac4d499e